import axios from 'axios'
import userStore from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'

export async function getBillingToken(stripeToken, stripeRef) {
    var user = userStore.getState().user
    var intentObj = await setupIntent();

    var confirmIntentObj = await stripeRef.handleCardSetup(intentObj.data && intentObj.data.client_secret,{
      payment_method_data: {
        billing_details: {
          "address": {
            "country": stripeToken.card.country,
            "city": stripeToken.card.address_city,
            "line1": stripeToken.card.address_line1,
            "state": stripeToken.card.address_state,
            "postal_code": stripeToken.card.address_zip
          },
          "name": stripeToken.card.name
        }
      }
    })
    
    if(confirmIntentObj.error) {
      throw new Error(confirmIntentObj.error.message)
    }

    var token = await getToken();
    try {
      var r = await validate_stripe_customer(token, confirmIntentObj, stripeToken, user);
      var status = r.data.cardStatus;
      if (status.address_zip_check !== 'pass' && status.address_zip_check !== 'unavailable')
        throw new Error('Your zip code is invalid')
      if (status.cvc_check !== 'pass' && status.cvc_check !== 'unavailable')
        throw new Error('Your CVC is invalid')
      }
    catch (err) {
      throw new Error(err.response && err.response.data && err.response.data.message)
    }
    return {
      stripeToken: stripeToken,
      requestId: r.data.requestId
    }
  }

function setupIntent() {
  return getToken().then(token =>axios({
    method: 'POST',
    url: `${window.settings.apiBaseUrl}/payments/stripe/setup_intent`,
    data: {},
    headers: {
      'Authorization': token,
      'x-api-key': window.settings.baseAPIKey
    },
    params: {
      site: window.settings.internalName
    }
  }))
}

function validate_stripe_customer(token, confirmIntentObj, stripeToken, user) {
  return axios({
    url: `/payments/stripe/validate_stripe_customer`,
    baseURL: window.settings.apiBaseUrl,
    method: 'POST',
    params: { site: window.settings.internalName, platform: 'web_browser' },
    headers: { 
      'Authorization': token,
      'x-api-key': window.settings.baseAPIKey
    },
    data: { 
      token: stripeToken.id, 
      email: user && user.email, 
      paymentMethodId: confirmIntentObj.setupIntent && confirmIntentObj.setupIntent.payment_method 
    }
  })
}